'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const getFileVisibilityFailureNotification = () => ({
  type: 'danger',
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'FileManagerDashboard.notifications.fileVisibility.error.title'
  }),
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'FileManagerDashboard.notifications.fileVisibility.error.message'
  })
});
const getExportNotification = type => ({
  notification: {
    type,
    titleText: I18n.text(`FileManagerDashboard.notifications.export.${type}.title`),
    message: type === 'danger' && I18n.text(`FileManagerDashboard.notifications.export.${type}.message`)
  }
});
export const getExportSuccessNotification = () => getExportNotification('success');
export const getExportFailureNotification = () => getExportNotification('danger');
const BASE_VISIBILITY_I18N_KEY = 'FileManagerDashboard.notifications.bulkChangeFileVisibility';
const getBulkVisibilityAlertNotificationTitle = (type, fileCount) => {
  if (type === 'danger') {
    return I18n.text(`${BASE_VISIBILITY_I18N_KEY}.danger.title`);
  } else if (isNaN(parseInt(fileCount, 10))) {
    return I18n.text(`${BASE_VISIBILITY_I18N_KEY}.success.title.undefinedCount`);
  } else {
    return I18n.text(`${BASE_VISIBILITY_I18N_KEY}.success.title`, {
      count: fileCount
    });
  }
};
const getBulkChangeVisibilityNotification = (type, fileCount = '') => ({
  type,
  titleText: getBulkVisibilityAlertNotificationTitle(type, fileCount),
  message: I18n.text(`FileManagerDashboard.notifications.bulkChangeFileVisibility.${type}.message`)
});
export const getBulkChangeVisibilitySuccessNotification = fileCount => getBulkChangeVisibilityNotification('success', fileCount);
export const getBulkChangeVisibilityFailureNotification = () => getBulkChangeVisibilityNotification('danger');
export const getNestedFileCountFailureNotification = () => ({
  type: 'warning',
  sticky: true,
  titleText: I18n.text(`FileManagerDashboard.notifications.bulkChangeFileVisibility.fileCountFailed.title`),
  message: I18n.text(`FileManagerDashboard.notifications.bulkChangeFileVisibility.fileCountFailed.message`)
});